import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const updateChannel = createAsyncThunk("updateChannel", async ({ id, values }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`channel/${id}`, values);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const UpdateChannelSlice = createSlice({
	name: "UpdateChannelSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetUpdateChannelState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(updateChannel.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(updateChannel.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(updateChannel.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetUpdateChannelState } = UpdateChannelSlice.actions;
export default UpdateChannelSlice.reducer;
